import { render, staticRenderFns } from "./OptionCard.vue?vue&type=template&id=81d7f0ec&scoped=true"
import script from "./OptionCard.vue?vue&type=script&lang=js"
export * from "./OptionCard.vue?vue&type=script&lang=js"
import style0 from "./OptionCard.vue?vue&type=style&index=0&id=81d7f0ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d7f0ec",
  null
  
)

export default component.exports